<template>
    <div class="tables new-updated-design px-0 px-md-0 pt-4 pt-md-0 pb-4">
        <div v-if="isLoading" class="loader-overlay">
            <div class="spinner"></div>
        </div>
        <b-card no-body>
            <!-- Tabs Header -->
            <b-tabs card v-model="activeTab" @input="onTabChange">
                <b-tab :title="$t('dashboard.bookings')" active></b-tab>
                <b-tab :title="$t('dashboard.check_in_guests')"></b-tab>
                <b-tab :title="$t('dashboard.check_out_guests')"></b-tab>
            </b-tabs>

            <!-- Tab Content -->
            <div class="row mt-3">
                <div class="col-lg-12 grid-margin stretch-card properties-table">
                    <div class="container mw-100">
                        <div class="card">
                            <div class="card-header">
                                <h4 class="card-title">{{ currentTabTitle }}</h4>
                            </div>
                            <div class="card-body">

                                <!-- Vue Good Table -->
                                <vue-good-table mode="remote" :columns="columns" :rows="rows" :totalRows="totalRecords"
                                    :search-options="{ enabled: true, placeholder: $t('common.search_placeholder')}" :pagination-options="{
                                        enabled: true,
                                        perPage: serverParams.perPage,
                                        perPageDropdown: [5, 10, 15, 20]
                                    }" :sort-options="{ enabled: false }" @on-page-change="onPageChange"
                                    @on-per-page-change="onPerPageChange" @on-search="onSearch">
                                    <!-- Row Template -->
                                    <template slot="table-row" slot-scope="props">
                                        <template v-if="activeTab === 0">
                                            <span v-if="props.column.field === 'name'">{{ props.row.user.name }}</span>
                                            <span v-else-if="props.column.field === 'email'">{{ props.row.user.email
                                            }}</span>
                                            <span v-else-if="props.column.field === 'mobile_phone'">{{
                                                props.row.phone_number || props.row.user?.mobile_phone || '-' }}</span>
                                            <span v-else-if="props.column.field === 'amount'">{{
                                                props.row.payment_currency }} {{ props.row.amount
                                                }}</span>
                                            <span v-else-if="props.column.field === 'property_type'">
                                                {{ $t('property_detail.' + props.row.property.property_type) }}
                                            </span>
                                            <span v-else-if="props.column.field === 'security_deposit_amount'">
                                                {{ props.row.security_deposit ? (props.row.payment_currency + ' ' + props.row.security_deposit.amount) : '-' }}
                                            </span>
                                            <span v-else-if="props.column.field === 'security_deposit_status'">
                                                <span v-if="props.row.security_deposit" :class="depositStatusClass(props.row.security_deposit.status)">
                                                    {{ formatDepositStatus(props.row.security_deposit.status) }}
                                                </span>
                                                <span v-else>-</span>
                                            </span>
                                            <span v-else-if="props.column.field === 'action'" class="text-nowrap">
                                                <b-button @click="propertyDetail(props.row.property.id)"
                                                    class="mr-1 btn-info new-primary-outline-btn" size="sm">
                                                    {{ $t('property_detail.Property_Detail') }}
                                                </b-button>
                                                <b-button @click="bookingDetail(props.row.id)"
                                                    class="mr-1 btn-secondary new-primary-btn" size="sm">
                                                    {{ $t('property_detail.Booking_detail') }}
                                                </b-button>
                                            </span>
                                        </template>

                                        <template v-else-if="activeTab === 1">
                                            <span v-if="props.column.field === 'name'">{{ props.row.user.name }}</span>
                                            <span v-else-if="props.column.field === 'start_date'">{{
                                                formatDate(props.row.start_date) }}</span>
                                            <span v-else-if="props.column.field === 'email'">{{ props.row.user.email
                                            }}</span>
                                            <span v-else-if="props.column.field === 'property_type'">
                                                {{ $t('property_detail.' + props.row.property.property_type) }}
                                            </span>
                                            <!-- <span v-else-if="props.column.field === 'action'">
                                                <b-button v-if="!props.row.guest_check_in_out?.is_checked_in"
                                                    variant="success" size="sm" @click="handleCheckIn(props.row)">
                                                    {{ $t('Check-in') }}
                                                </b-button>
                                                <span v-else class="text-success font-weight-bold">{{ $t('Checked In')
                                                    }}</span>
                                            </span> -->
                                        </template>

                                        <template v-else-if="activeTab === 2">
                                            <span v-if="props.column.field === 'name'">{{ props.row.user.name }}</span>
                                            <span v-else-if="props.column.field === 'end_date'">{{
                                                formatDate(props.row.end_date) }}</span>
                                            <span v-else-if="props.column.field === 'email'">{{ props.row.user.email
                                            }}</span>
                                            <span v-else-if="props.column.field === 'property_type'">
                                                {{ $t('property_detail.' + props.row.property.property_type) }}
                                            </span>
                                            <!-- <span v-else-if="props.column.field === 'action'">
                                                <b-button
                                                    v-if="props.row.guest_check_in_out?.is_checked_in && !props.row.guest_check_in_out?.is_checked_out"
                                                    variant="danger" size="sm" @click="handleCheckOut(props.row)">
                                                    {{ $t('Check-out') }}
                                                </b-button>
                                                <span v-else-if="props.row.guest_check_in_out?.is_checked_out"
                                                    class="badge bg-primary font-weight-bold">
                                                    {{ $t('Checked Out') }}
                                                </span>
                                                <span v-else class="badge bg-danger text-white">
                                                    {{ $t('Not Checked In') }}
                                                </span>
                                            </span> -->
                                        </template>
                                    </template>

                                    <!-- No Data Template -->
                                    <template slot="emptystate">
                                        <div class="text-center text-muted py-2 w-100">
                                            {{ $t('common.no_data_available') }}
                                        </div>
                                    </template>
                                </vue-good-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import Vue from "vue";
import API from "@/api";
import moment from "moment";
import { debounce } from "lodash";

export default {
    name: "Spotters",
    data() {
        return {
            activeTab: 0,
            serverParams: {
                search: "",
                sort: [{ field: "id", type: "desc" }],
                page: 1,
                perPage: 10
            },
            rows: [],
            totalRecords: 0,
            isLoading: false
        };
    },
    computed: {
        columns() {
            switch (this.activeTab) {
                case 0:
                    return [
                        { label: this.$t("booking.Guest"), field: "name" },
                        { label: this.$t("booking.Guest_Email"), field: "email" },
                        { label: this.$t("booking.Guest_Contact"), field: "mobile_phone" },
                        { label: this.$t("booking.Amount"), field: "amount" },
                        { label: this.$t("dashboard.deposit_amount"), field: "security_deposit_amount" },
                        { label: this.$t("dashboard.deposit_status"), field: "security_deposit_status" },
                        { label: this.$t("properties_list.Property_Type"), field: "property_type" },
                        { label: this.$t("properties_list.action"), field: "action" }
                    ];
                case 1:
                    return [
                        { label: this.$t("booking.Guest"), field: "name" },
                        { label: this.$t("dashboard.check_in_date"), field: "start_date" },
                        { label: this.$t("booking.Guest_Email"), field: "email" },
                        { label: this.$t("properties_list.Property_Type"), field: "property_type" },
                        // { label: this.$t("properties_list.action"), field: "action" }
                    ];
                case 2:
                    return [
                        { label: this.$t("booking.Guest"), field: "name" },
                        { label: this.$t("dashboard.check_out_date"), field: "end_date" },
                        { label: this.$t("booking.Guest_Email"), field: "email" },
                        { label: this.$t("properties_list.Property_Type"), field: "property_type" },
                        // { label: this.$t("properties_list.action"), field: "action" }
                    ];
                default:
                    return [];
            }
        },
        currentTabTitle() {
            const titles = [
                this.$t("properties_list.View_Bookings"),
                this.$t("dashboard.check_in_guests"),
                this.$t("dashboard.check_out_guests")
            ];
            return titles[this.activeTab];
        }
    },
    methods: {
        onTabChange(index) {
            this.activeTab = index;
            this.rows = [];
            this.serverParams.page = 1;
            this.loadItems();
        },

        onPageChange(params) {
            this.serverParams.page = params.currentPage;
            this.loadItems();
        },

        onPerPageChange(params) {
            this.serverParams.perPage = params.currentPerPage;
            this.serverParams.page = 1;
            this.loadItems();
        },

        onSearch: debounce(function (searchQuery) {
            this.serverParams.search = searchQuery;
            this.serverParams.page = 1;
            this.loadItems();
        }, 300),

        loadItems() {
            this.isLoading = true;

            const flattenRow = (row) => {
                const base = {
                    ...row,
                    guestName: row.user?.name || '',
                    guestEmail: row.user?.email || '',
                    guestContact: row.user?.mobile_phone || '',
                    propertyType: row.property?.property_type || '',
                };

                if (this.activeTab === 1) {
                    // Check-in Guests Tab
                    base.startDate = row.start_date;
                    base.isCheckedIn = row.guest_check_in_out?.is_checked_in === 1;
                } else if (this.activeTab === 2) {
                    // Check-out Guests Tab
                    base.endDate = row.end_date;
                    base.isCheckedIn = row.guest_check_in_out?.is_checked_in === 1;
                    base.isCheckedOut = row.guest_check_in_out?.is_checked_out === 1;
                }

                return base;
            };

            const onSuccess = (data) => {
                const fetchedRows = data.data || [];
                this.rows = fetchedRows.map(flattenRow);
                this.totalRecords = data.totalRecords || 0;
                this.noDataFound = this.rows.length === 0;
                this.isLoading = false;
            };

            const onError = (err) => {
                console.error('Failed to load data', err);
                this.isLoading = false;
                this.$showNotification({ message: this.$t('errors.failed_load_data') }, "error");
            };

            // Fetch data based on active tab
            switch (this.activeTab) {
                case 0: // Bookings
                    API.getAllBookings(this.serverParams, onSuccess, onError);
                    break;
                case 1: // Check-in Guests
                    API.getAllCheckInGuests(this.serverParams, onSuccess, onError);
                    break;
                case 2: // Check-out Guests
                    API.getAllCheckOutGuests(this.serverParams, onSuccess, onError);
                    break;
            }
        },
        bookingDetail(id) {
            this.$router.push({ name: 'booking_detail', params: { id } });
        },

        propertyDetail(id) {
            this.$router.push({ name: 'properties_detail', params: { id } });
        },
        // handleCheckIn(row) {
        //     API.checkInGuest({
        //         payment_id: row.id,
        //         date_time: moment().format('YYYY-MM-DD HH:mm:ss')
        //     }, () => {
        //         this.$swal({
        //             title: this.$t('Checked In'),
        //             text: this.$t('Guest successfully checked in'),
        //             icon: 'success'
        //         });
        //         this.loadItems();
        //     }, this.handleApiError);
        // },
        // handleCheckOut(row) {
        //     API.checkOutGuest({
        //         payment_id: row.id,
        //         date_time: moment().format('YYYY-MM-DD HH:mm:ss')
        //     }, () => {
        //         this.$swal({
        //             title: this.$t('Checked Out'),
        //             text: this.$t('Guest successfully checked out'),
        //             icon: 'success'
        //         });
        //         this.loadItems();
        //     }, this.handleApiError);
        // },
        handleApiError(err) {
            console.error(err);
            this.$swal({
                title: 'Error',
                type: 'error',
                text: this.$t('errors.failed_load_data'),
                icon: 'error'
            });
        },
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        formatDate(date) {
            return moment(date).format('DD-MM-YYYY');
        },
        formatDepositStatus(status) {
            if (!status) return '-';
            return status.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
        },
        depositStatusClass(status) {
            const map = {
                held: 'badge bg-info text-white',
                awaiting_release: 'badge bg-primary text-white',
                host_claimed: 'badge bg-danger text-white',
                refund_pending: 'badge bg-warning text-dark',
                refunded: 'badge bg-secondary text-white',
                resolved: 'badge bg-success text-white',
            };
            return map[status] || 'badge bg-secondary text-white';
        },
        errorMsg(err) {
            console.log(err);
            this.$showNotification({ message: 'Failed system error' }, "error")
        }
    },
    watch: {
        "$i18n.locale"(newVal, oldVal) {
            this.loadItems(); // reload for updated headers
        }
    },
    mounted() {
        this.isLoading = true;
        Vue.prototype.$EventBus.$on('changeLanguage', this.updateColumnLabels);
        this.loadItems();
        this.updateColumnLabels();
    }
};
</script>

<style scoped>
button.btn.new-primary-outline-btn, button.btn.new-primary-btn {
    padding: 10px !important;
    border-radius: 5px !important;
    font-size: 16px !important;
    line-height: 1 !important;
    height: max-content !important;
}
button.btn.new-primary-btn {
    background: #70D3FF !important;
    border-color: #70D3FF !important;
    color: #fff !important;
}
button.btn.new-primary-btn:hover {
    background: #fff !important;
    color: #70D3FF !important;
    border-color: #70D3FF !important;
}
html body button.btn.new-primary-outline-btn {
    color: #70D3FF !important;
    background-color: #fff !important;
}
html body button.btn.new-primary-outline-btn:hover {
    background: #70D3FF !important;
    color: #fff !important;
    border-color: #70D3FF !important;
}
</style>
<style>
.nav-tabs .nav-item .nav-link.active {
    border-radius: 0;
    background: #70D3FF;
    border: 1px solid #70D3FF;
    color: #fff;
}

.card-header .nav-tabs {
    display: flex;
    margin-bottom: 0;
}

.nav-tabs .nav-item .nav-link {
    border: 1px solid #dcdfe6;
    font-weight: bold;
}

.tab-content {
    display: none;
}

.vgt-global-search {
    padding: 6px;
    border-radius: 10px;
    width: 100%;
    max-width: 275px;
    border: 1px solid rgb(220, 223, 230);
    background: #fff;
    margin-bottom: 15px;
}

.vgt-global-search input {
    border: 0;
}

.sidebar .collapse.show ul.nav.flex-column.sub-menu {
    padding: 0 !important;
    list-style: none !important;
    border-radius: 0 0 10px 10px;
    border-top: 1px solid #eee;
}

@media (max-width: 499px) {
    .card-header .nav-tabs .nav-item {
        width: 100%;
    }
}
</style>